import type {Price} from '@/redux/v1/models';

import {t} from 'i18next';

type PriceFormatOptions = {
  fractionDigits?: number;
  locale?: string;
  canWrap?: boolean;
  signDisplay?: Intl.NumberFormatOptions['signDisplay'];
};

const MONETARY_FRACTION_VALUE = 100;
const DEFAULT_FRACTION_DIGITS = 2;

export const priceFormat = (
  price: Price,
  {
    locale = import.meta.env.VITE_LOCALE,
    fractionDigits = DEFAULT_FRACTION_DIGITS,
    canWrap = false,
    signDisplay,
  }: PriceFormatOptions = {}
) => {
  const formatedPrice = Intl.NumberFormat(locale, {
    style: 'currency',
    useGrouping: true,
    currency: price.currency,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    signDisplay,
  }).format(price.amount / MONETARY_FRACTION_VALUE);

  if (canWrap) {
    // replace NO-BREAK SPACE with regular space
    return formatedPrice.replace(/\u00A0/u, ' ');
  }
  return formatedPrice;
};

export const priceFormatPerPerson = (price: Price) => {
  return t('general:pricePerPersonShort', {
    price: price.amount,
    currency: price.currency,
  });
};

export const numberFormat = (
  value: number,
  locale = import.meta.env.VITE_LOCALE
) => {
  return Intl.NumberFormat(locale, {
    style: 'decimal',
  }).format(value);
};

type PercentFormatOptions = {
  maximumFractionDigits?: number;
  locale?: string;
};

export const percentFormat = (
  /**
   * @example 10 => '10%'
   * @example 10.25 => '10.3%'
   */
  value: number,
  {
    locale = import.meta.env.VITE_LOCALE,
    maximumFractionDigits = 1,
  }: PercentFormatOptions = {}
) => {
  return Intl.NumberFormat(locale, {
    style: 'percent',
    maximumFractionDigits,
  }).format(value / 100);
};
